<template>
  <div class="filter">
    <div class="filter-item" @click="change('image')">
      <span class="filter-name" :class="{active: currentItem == 'image'}">照片</span>
      <span class="filter-value">（{{photoNum}}）</span>
    </div>
    <div class="filter-item" @click="change('video')">
      <span class="filter-name" :class="{active: currentItem == 'video'}">视频</span>
      <span class="filter-value">（{{videoNum}}）</span>
    </div>
    <div class="filter-item">
      <span class="filter-name">浏览</span>
      <span class="filter-value">（{{viewNum}}）</span>
    </div>
    <div class="filter-item filter-qrcode" @click="$emit('qrcode')">
      <div class="filter-icon item-qrcode"></div>
    </div>
  </div>
</template>

<script>
import '@/assets/less/albumFilter.less'
export default {
  props:{
    photoNum: {
      type: Number,
      default: 0
    },
    videoNum: {
      type: Number,
      default: 0
    },
    viewNum: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      currentItem: 'image'
    }
  },
  methods: {
    change(type){
      this.currentItem = type;
      this.$emit('change',type)
    },
  }
}
</script>
